/* eslint-disable eqeqeq */
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { CepVerify } from './cep.service';
import { dataAll, dataCreate, dataDelete, dataEdit } from './data.service';
import { Proposal } from './wf.service';
import {getClientByCpf} from './client.service';

export const createLead = async (newData) => {
  const response = await dataCreate('/leads', newData);
  return response;
};

export const editLead = async (newData, dataID) => {
  const response = await dataEdit('/leads', newData, dataID);
  return response;
};
export const goToNextStatus = async (dataID) => {
    const response = await dataAll(`/leads/next-status/${dataID}`)
    return response;
};

export const deleteLead = async (dataID) => {
  const response = await dataDelete('/leads', dataID);
  return response;
};

export const checkCPF = async (e, values, setValues) => {
  if (values?.client_Cpf) {
    setValues({ ...values, client_Cpf: e.target.value.replace(/[^0-9]/g, '') });
    const client = await getClientByCpf(e.target.value.replace(/[^0-9]/g, ''));
      // context?.values?.clients.find((c) => c.cpf === e.target.value.replace(/[^0-9]/g, ''));
    if (client) {
      setValues({
        ...values,
        client_name: client.name,
        client_Cpf: client.cpf,
        client_birth_date: client.birth_date,
        client_CEP: client.address.cep,
        client_address_street: client.address.street,
        client_address_number: client.address.number,
        client_address_comp: client.address.comp,
        client_address_district: client.address.district,
        client_address_city: client.address.city,
        client_address_state: client.address.state,
        client_cellphone: client.cellphone,
        client_phone: client.phone,
        client_Email: client.mail,
        client_Rg: client.rg,
      });
    }
  }
};

export const checkProposal = async (context, values, setValues) => {
  if (values?.partner !== null && values?.proposal !== '') {
    try {
      let resp;
      if (context?.values?.leads.find((l) => l.proposal === values?.proposal)) {
        resp = context?.values?.leads.find((l) => l.proposal === values?.proposal);
      } else resp = await Proposal(values?.partner.code_wf, values?.proposal);
      const phone = `${resp.contato.find((r) => r.tipocodigo === 2)?.ddd}${
        resp.contato.find((r) => r.tipocodigo === 2)?.telefone
      }`.replace(/[^0-9]/g, '');
      const cellphone = `${resp.contato.find((r) => r.tipocodigo === 1)?.ddd}${
        resp.contato.find((r) => r.tipocodigo === 1)?.telefone
      }`.replace(/[^0-9]/g, '');
      // console.log('phone', phone.replace(/[^0-9]/g, ''));
      // console.log('cellphone', cellphone);
      const client = context?.values?.clients.find((c) => c.cpf === resp.cpf);
      const insurance = context?.values?.insurances.find((i) => i.name.includes(resp.tipoEstoque));
      if (resp) {
        const now = DateTime.now();
        const proposalDate = DateTime.fromISO(resp.dataProposta);
        // eslint-disable-next-line no-unused-vars
        const diffProposalNow = now.diff(proposalDate, ['hours']);
        setValues({
          ...values,
          client_name: client ? client.name : resp.clienteNome,
          client_Cpf: client ? client.cpf : resp.cpf,
          client_birth_date: client ? client.birth_date : resp.dataNascimento.split('T')[0],
          client_CEP: client ? client.address.cep : resp.cep,
          client_address_street: client ? client.address.street : resp.enderecoLogradouro,
          client_address_number: client ? client.address.number : resp.enderecoNumero.replace(/\s/g, ''),
          client_address_comp: client ? client.address.comp : resp.enderecoComplemento,
          client_address_district: client ? client.address.district : resp.bairro,
          client_address_city: client ? client.address.city : resp.cidade,
          client_address_state: client ? client.address.state : '',
          client_cellphone: client?.cellphone ? client.cellphone : cellphone,
          client_phone: client?.phone ? client?.phone : phone,
          client_Email: client ? client.mail : resp.email,
          proposal_date: resp.dataProposta,
          product: resp.veiculoDescricao,
          product_chassis: resp.chassi,
          product_license_plate: resp.placa,
          product_year: resp.ano,
          product_brand: resp.marca,
          insurance,
          // indication_on_time: diffProposalNow <= context?.values?.indication_on_time.value ? '1' : '0',
        });
      }
    } catch (err) {
      //
    }
  }
  return false;
};

export const checkCEP = async (values, setValues) => {
  if (values?.client_CEP != '') {
    const response = await CepVerify(values?.client_CEP.replace(/[^\d]/g, ''));
    if (response) {
      setValues({
        ...values,
        client_address_state: response.uf,
        client_address_city: response.cidade,
        client_address_district: response.bairro,
        client_address_street: response.logradouro,
      });
    }
  }
};

export const handleCall = async (values, setValues, setFinish, status) => {
    toast.info('Ligando!', { position: 'top-center' });
    if (values?.status?.id < 3) {
      setValues({
        ...values,
        status: status.find((s) => s.id == 3),
      });
      setFinish(true);
    }
  };

export const verify = (values, setValues, car, permissions) => {
    let lostSale = values?.lost_sale;
    let productBrand = values?.product_brand;
    let productChassis = values?.product_chassis;
    let productLicensePlate = values?.product_license_plate;
    let productYear = values?.product_year;
    let backupCar = values?.backup_car;
    let pagueMenos = values?.pague_menos;
    let seguroConteudo = values?.seguro_conteudo;
    let competitorBroker = values?.competitor_broker;
    let Sold = values?.sold;

    // let lostSale = values?.lost_sale;

    if (!permissions?.can_finish) {
      backupCar = null;
      pagueMenos = null;
      seguroConteudo = null;
      Sold = null;
    }

    if (values?.sold?.id === 2) {
      lostSale = null;
    }
    if (values?.sold?.id === 1 && values?.lost_sale?.id !== 5) {
      competitorBroker = null;
    }

    if (car === false) {
      productBrand = '';
      productChassis = '';
      productLicensePlate = '';
      productYear = '';
    }

    setValues({
      ...values,
      lost_sale: lostSale,
      product_brand: productBrand,
      product_chassis: productChassis,
      product_license_plate: productLicensePlate,
      product_year: productYear,
      backup_car: backupCar,
      pague_menos: pagueMenos,
      seguro_conteudo: seguroConteudo,
      competitor_broker: competitorBroker,
      sold: Sold,
    });
  };

  export const getLeadPermissions = async (id) => {
    const response = await dataAll(`/leads-permissions/${id}`);
    return response;
  };